import { render } from "./upload_video_single.vue?vue&type=template&id=6520af4d&scoped=true"
import script from "./upload_video_single.vue?vue&type=script&lang=js"
export * from "./upload_video_single.vue?vue&type=script&lang=js"

import "./upload_video_single.vue?vue&type=style&index=0&id=6520af4d&scoped=true&lang=css"
import "./upload_video_single.vue?vue&type=style&index=1&id=6520af4d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6520af4d"]])

export default __exports__